import * as $ from 'jquery';
import showError from './central/showError';
import { lookFor } from './central';
import { ensureSod } from './central/utils';
var Helper = (function () {
    function Helper() {
    }
    Helper.clientContextExecute = function (ctx, showErrorMessage) {
        if (showErrorMessage === void 0) { showErrorMessage = true; }
        var dfd = $.Deferred();
        ctx.executeQueryAsync(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            dfd.resolve(args);
        }, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            function CustomError(message, customArgs) {
                this.message = message;
                this.stack = new Error().stack;
                this.customArgs = customArgs;
            }
            CustomError.prototype = Object.create(Error.prototype);
            CustomError.prototype.name = 'CustomError';
            var error = new CustomError('SP.ClientContext - executeQueryAsync', args);
            dfd.reject(error);
            showErrorMessage && showError(error);
        });
        return dfd.promise();
    };
    Helper.getUrlParameter = function (name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
    Helper.loadConfigValue = function (key) {
        var _this = this;
        var p = this.cfgValues[key];
        if (p) {
            return p;
        }
        return this.context().then(function (ctx) {
            var list = ctx
                .get_site()
                .get_rootWeb()
                .get_lists()
                .getByTitle('Portal-Konfiguration');
            var query = new SP.CamlQuery();
            query.set_viewXml("<View><Query><Where><Eq><FieldRef Name='Title'/><Value Type='Text'>" + key + "</Value></Eq></Where></Query><RowLimit>1</RowLimit></View>");
            var items = list.getItems(query);
            ctx.load(items);
            _this.cfgValues[key] = p = _this.clientContextExecute(ctx).then(function () {
                var enumerator = items.getEnumerator();
                while (enumerator.moveNext()) {
                    var item = enumerator.get_current();
                    var value = item.get_item('portalCfgValue');
                    return value;
                }
            });
            return p;
        });
    };
    Helper.pageLoaded = function () {
        if (!Helper.pageLoaded$) {
            Helper.pageLoaded$ = $.Deferred();
            _spBodyOnLoadFunctions.push(function () {
                if (typeof window.myTitle !== 'undefined') {
                    var interval_1 = window.setInterval(function () {
                        console.log('check if assistent was loaded...');
                        if (document.getElementsByClassName('detail__teaser').length) {
                            window.clearInterval(interval_1);
                            Helper.pageLoaded$.resolve();
                        }
                    }, 250);
                }
                else {
                    Helper.pageLoaded$.resolve();
                }
            });
        }
        return Helper.pageLoaded$.promise();
    };
    Helper.addNotification = function (message, sticky) {
        if (sticky === void 0) { sticky = false; }
        var deffer = $.Deferred();
        SP.SOD.executeFunc('SP.core.js', 'SP.UI.Notify', function () {
            var id = SP.UI.Notify.addNotification(message, sticky);
            deffer.resolve(id);
        });
        return deffer.promise();
    };
    Helper.cfgValues = {};
    return Helper;
}());
if (!Helper.context) {
    var dfdCtx_1 = $.Deferred();
    SP.SOD.executeFunc('sp.js', 'SP.ClientContext', function () {
        dfdCtx_1.resolve(new SP.ClientContext(_spPageContextInfo.webAbsoluteUrl));
    });
    Helper.context = function () { return dfdCtx_1.promise(); };
}
if (!Helper.taxSession) {
    var createTaxSession_1 = function () {
        var dfdTax = $.Deferred();
        Helper.context().then(function (ctx) {
            ensureSod('sp.taxonomy.js', 'SP.Taxonomy.TaxonomySession', function () {
                SP.SOD.registerSod('sp.taxonomy.js', '/_layouts/15/sp.taxonomy.js?rev=gXJxm9XW5wXmexhrflC7sQ');
            }).then(function () {
                var tax = SP.Taxonomy.TaxonomySession.getTaxonomySession(ctx);
                ctx.load(tax);
                var stores = tax.get_termStores();
                ctx.load(stores);
                ctx.executeQueryAsync(function () {
                    dfdTax.resolve({ tax: tax, termStore: lookFor(stores, function (s) { return s.get_isOnline(); }) });
                }, function (ex) {
                    showError(ex);
                    return $.Deferred().reject(ex);
                });
            });
        });
        return dfdTax.promise();
    };
    Helper.taxSession = function (createNew) {
        if (createNew) {
            return createTaxSession_1();
        }
        else {
            var result = window.riHelperTaxSession;
            if (result) {
                return result;
            }
            else {
                return (window.riHelperTaxSession = createTaxSession_1());
            }
        }
    };
}
if (!window.$itacs) {
    window.$itacs = {};
}
if (!window.$itacs.helper) {
    window.$itacs.helper = Helper;
}
export default window.$itacs.helper;
if (!window.$itacs.$) {
    window.$itacs.$ = $.noConflict(true);
    if (typeof window.NotifyScriptLoadedAndExecuteWaitingJobs != 'undefined') {
        window.NotifyScriptLoadedAndExecuteWaitingJobs('ixjquery.js');
    }
}
if (typeof window['NotifyScriptLoadedAndExecuteWaitingJobs'] != 'undefined') {
    window['NotifyScriptLoadedAndExecuteWaitingJobs']('rihelper.js');
}
